export default {
    translation: {
        title: "Америка",
        applications: "Пуск",
        full_text: "Полный текст",
        vehicle: {
            status: "Движемся на {{direction}} на скорости {{speed}} миль в час"
        },
        talkie: {
            drivers_nearby_singular: "Один водитель рядом",
            drivers_nearby_plural: "{{count}} водителей рядом"
        },
        settings: {
            save_progress_description:
                "Сохраните прогресс на дискету для резервной копии или переноса между компьютерами.",
            save_progress_action: "Сохранить прогресс",
            load_progress_action: "Загрузить прогресс...",
            display_units: "Единицы измерения",
            imperial: "Американские",
            metric: "Метрические",
            start_over_description:
                "Завершите путешествие досрочно. Текущий прогресс будет стёрт. Это действие нельзя отменить.",
            start_over_action: "Начать заново"
        },
        feedback: {
            message: "Сообщение",
            contact_info: "Контактные данные (не обязательно)",
            send: "Отправить",
            sending: "Отправляется..."
        },
        radio: {
            no_reception: "Нет радио-станций поблизости",
            low_signal: "Слабый сигнал",
            turn_off: "Выкл.",
            turn_on: "Вкл.",
            next_station: "Дальше",
            unmute: "Вкл. звук",
            mute: "Выкл. звук"
        },
        photos: {
            source: "От Mapillary",
            empty: "Ищу, что сфотографировать..."
        },
        news: {
            loading: "Просматриваю местные заголовки...",
            nothing_found: "Ничего не найдено."
        },
        metrics: {
            duration_title: "Время за рулём",
            duration_value: "{{days}}д {{hours}}ч {{minutes}}м",
            distance_title: "Пройденная дистанция",
            emissions_title: "Выбросы CO2",
            emissions_value_g: "{{g}} г",
            emissions_value_kg: "{{kg}} кг",
            states_visited_title: "Посещено штатов",
            cairns_discovered_title: "Каирнов найдено",
            exploration_title: "Исследовано"
        },
        compass: {
            north_east: "северо-восток",
            east: "восток",
            south_east: "юго-восток",
            south: "юг",
            south_west: "юго-запад",
            west: "запад",
            north_west: "северо-запад",
            north: "север"
        },
        landing: {
            about_title: "О игре",
            start_title: "Начать",
            features_title: "Особенности",
            about_headline: "America: симулятор путешествия на авто в вашем браузере",
            about_paragraph_1:
                "Safari, Chrome, Edge. Это порталы в бесконечные уголки веба.\n"
                + "America — ваш портал в другой вид просторных ландшафтов: природные\n"
                + "чудеса Соединённых Штатов, где столько же всего для изучения, в выбранном\n"
                + "вами темпе.",
            about_paragraph_2:
                "От величественных пейзажей до тихих моментов у дороги — вы управляете\n"
                + "путешествием через интерфейс в стиле настольного компьютера: карта, живое\n"
                + "радио, статьи из энциклопедии, фото, статистика, дневник и многое другое.\n"
                + "Без очков и спешки: главное — случайные открытия и атмосфера. Откройте\n"
                + "в современном браузере; ничего устанавливать не нужно.",
            about_paragraph_3:
            "Ваше путешествие может идти вдоль тихоокеанского побережья, по трассе 66 через"
                + "равнины, через Скалистые горы к национальным паркам или по просёлочным дорогам"
                + "Новой Англии. Каждая остановка открывает местную историю: что видел этот город,"
                + "каньон или смотровая площадка, что играет по радио и какая сейчас погода. Это"
                + "симулятор путешествия, чтобы исследовать США в своём темпе, в браузере, на любом"
                + "устройстве.",

            trips_title: "Путешествия",
            trips_list: [
                { label: "Виртуальное путешествие на авто", url: "/virtual-road-trip/" },
                { label: "Путешествие по США", url: "/us-road-trip/" },
                { label: "Путешествие по национальным паркам", url: "/national-parks-road-trip/" },
                { label: "Путешествие по трассе 66", url: "/route-66-road-trip/" },
                { label: "Исследуйте Америку", url: "/explore-america/" },
                { label: "Путешествие через Америку", url: "/road-trip-across-america/" }
            ],
            watch_commercial: "Смотреть рекламу",
            start_cta: "Начать путешествие",
            start_cta_lead: "Без установки. Работает в вашем браузере.",
            features_lede:
                "Как только путешествие начнётся, вы настроите панель управления из набора\n"
                + "America для путешествий на авто. Каждое окно — это новый способ\n"
                + "познакомиться со страной. От местного радио до рации с другими водителями —\n"
                + "вы обязательно откроете что-то новое в каждой поездке.",
            features_list: [
                "Карта с маршрутизацией и исследованием по всей территории США",
                "Радио в прямом эфире и привязанные к месту статьи и фото",
                "Дневник, статистика, фото и энциклопедия",
                "Друзья, голосовой чат и общие дорожные ориентиры (каирны)",
                "Работает в браузере на телефоне или компьютере; без скачивания",
            ],
            media_alt: "America Complete Edition: коробка с программным обеспечением и CD",
            slideshow_alt: "Фотографии пейзажей из симулятора путешествия America, изображение",
            og_title: "America: Симулятор путешествия на авто",
            og_description:
                "Исследуйте природные чудеса Соединённых Штатов в увлекательном симуляторе путешествия на авто в стиле настольного компьютера. Карты, радио, дневник и случайные открытия — прямо в вашем браузере.",
            twitter_description:
                "Исследуйте природные чудеса Соединённых Штатов в увлекательном симуляторе путешествия на авто в стиле настольного компьютера. Без установки.",
            meta_description:
                "Путешествуйте по реальным дорогам США и исследуйте природные чудеса в бесплатном симуляторе в браузере. Карты, радио, фото. Без скачивания.",
            jsonld_description:
                "America — это симулятор путешествия на авто в вашем браузере: исследуйте природные чудеса США в своём темпе с картами, радио, фото и интерфейсом в стиле настольного компьютера. Без скачивания; начните путешествие онлайн.",
            jsonld_genre: ["Симулятор путешествия на авто", "Игра-исследование", "Браузерная игра"],
            page_title: "Симулятор путешествия по США | America",
            html_lang: "ru",
            og_locale: "ru_RU",
            og_locale_alternate: ["en_US", "es_ES", "fr_FR", "de_DE", "ja_JP", "ko_KR", "zh_CN", "pt_BR"],
            og_image_alt: "Скриншот симулятора путешествия на авто America",
            twitter_image_alt: "Скриншот симулятора путешествия на авто America",
        },
    }
};
